
import errorService from "./errorService";

const safeJsonParse = (value, defaultValue = null) => {
  if (value === null || value === undefined || value === "null" || value === "undefined") {
    return defaultValue;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    errorService.error(error);
    return defaultValue;
  }
};

export default safeJsonParse;
